export const REQUESTS_PATH = '/requests';

/**
 * Shareable deep link to one agent transcript — opens the side panel over the
 * Requests Explorer. Must stay in sync with the nested route in App.tsx.
 */
export function transcriptPath(threadId: string): string {
  return `${REQUESTS_PATH}/thread/${encodeURIComponent(threadId)}`;
}
